export const SUCCESS_GET_TRANSACCIONES = 'SUCCESS_GET_TRANSACCIONES'
export const FAILED_GET_TRANSACCIONES = 'FAILED_GET_TRANSACCIONES'
export const ERROR_GET_TRANSACCIONES = 'ERROR_GET_TRANSACCIONES'



export const SUCCESS_CONSULTAR_PRESENTACIONES_INICIADAS = 'SUCCESS_CONSULTAR_PRESENTACIONES_INICIADAS'
export const FAILED_CONSULTAR_PRESENTACIONES_INICIADAS = 'FAILED_CONSULTAR_PRESENTACIONES_INICIADAS'
export const ERROR_CONSULTAR_PRESENTACIONES_INICIADAS = 'ERROR_CONSULTAR_PRESENTACIONES_INICIADAS'

export const PORTAL_COMERCIOS = 1
